import { render, staticRenderFns } from "./Equiments.vue?vue&type=template&id=522e07be&scoped=true&"
import script from "./Equiments.vue?vue&type=script&lang=js&"
export * from "./Equiments.vue?vue&type=script&lang=js&"
import style0 from "./Equiments.vue?vue&type=style&index=0&id=522e07be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e07be",
  null
  
)

export default component.exports